
export default function WhyChooseUs() {
  const reasons = [
    {
      icon: "ri-shield-check-line",
      title: "Licensed & Insured",
      desc: "Fully licensed with comprehensive liability insurance for your peace of mind."
    },
    {
      icon: "ri-star-line",
      title: "5-Star Craftsmanship",
      desc: "Meticulous attention to detail on every project, big or small."
    },
    {
      icon: "ri-map-pin-line",
      title: "Serving All Alberta",
      desc: "Edmonton, Edson, Hinton, Whitecourt, Spruce Grove, and Mexico."
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Free Estimates",
      desc: "No-obligation quotes with transparent pricing and no hidden fees."
    },
    {
      icon: "ri-time-line",
      title: "On-Time Delivery",
      desc: "We respect your schedule and complete projects within agreed timelines."
    },
    {
      icon: "ri-customer-service-2-line",
      title: "24hr Response",
      desc: "Quick communication — we respond to all inquiries within 24 hours."
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-stone-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <div className="inline-block mb-4 px-5 py-2 bg-emerald-100 rounded-full">
            <span className="text-emerald-700 font-semibold text-sm tracking-wide uppercase">Why Sierra Kustom</span>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4 tracking-tight">
            Why Clients <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-700 to-emerald-500">Choose Us</span>
          </h2>
          <p className="text-gray-600 text-base max-w-xl mx-auto">
            Quality craftsmanship, reliable service, and honest pricing across every project
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((reason, i) => (
            <div
              key={i}
              className="bg-white border border-gray-100 rounded-2xl p-7 hover:shadow-lg hover:border-amber-100 transition-all duration-300 group"
            >
              <div className="w-12 h-12 bg-gradient-to-br from-amber-100 to-amber-50 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${reason.icon} text-amber-600 text-2xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{reason.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{reason.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
